// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"585":"5528f233","837":"5528f233"}[chunkId] + ".chunk.css";
};